// Module
var code = "<treatments></treatments>\n";
// Exports
module.exports = code;